import { useEffect } from "react";







export default function Adsense() {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }, []);

  return (
    <div style={{ margin: "20px 0", textAlign: "center" }}>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-4942463590341754"
        data-ad-slot="4116738356"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}